<template>
  <div id="contact">
    <figure class="contact-image contact-image-mobile" v-if="isMobile">
      <img src="../assets/img/fachada.webp"/>
    </figure>
    <ContactInfo />
    <figure class="contact-image" v-if="!isMobile">
      <img src="../assets/img/fachada.webp"/>
    </figure>
    <div class="map-container" v-if="!isMobile">
      <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3288.951888096704!2d-58.6620524234225!3d-34.478744750910266!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95bca369df551489%3A0xdc135d82ba636953!2sGrupo%20MSH%20S.A.!5e0!3m2!1ses-419!2sar!4v1710115491776!5m2!1ses-419!2sar" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
    </div>
  </div>
</template>

<script>
import ContactInfo from '../components/ContactInfo.vue'
import { EventBus } from '@/event-bus'
import { isMobile } from 'mobile-device-detect'

import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

export default {
  components: {
    ContactInfo
  },
  data () {
    return {
      isMobile
    }
  },
  mounted () {
    EventBus.$emit('showTitlePage', this.$t('contact.pageTitle'))
    EventBus.$emit('showContactsIcons', true)

    this.initParallax()
  },
  methods: {
    initParallax () {
      gsap.to('.contact-image img', {
        y: '-10%', // Mueve la imagen hacia arriba al hacer scroll
        ease: 'none',
        scrollTrigger: {
          trigger: '.contact-image',
          start: 'top bottom', // Cuando la imagen entra en pantalla
          end: 'bottom top', // Hasta que sale de pantalla
          scrub: 1 // Hace que el efecto se mantenga fluido
        }
      })
    }
  },
  watch: {
    '$i18n.locale': {
      handler () {
        EventBus.$emit('showTitlePage', this.$t('contact.pageTitle'))
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#contact{
  background-color: #1A1A1A;
  padding: var(--main-space);
  .contact-image {
    margin-top: calc(80px - 14px); // FIX PARA QUE QUEDE PERFECTAMENTE A 80PX SEPARADOS DEL OTRO ELEMENTO
    overflow: hidden;
    height: 800px;

    &.contact-image-mobile {
      margin-top: 80px;
      margin-bottom: 0;
    }

    img{
      width: 100%;
      object-fit: cover;
      object-position: center;
      height: 900px;
    }
  }
  .map-container {
    margin-top: 40px;
    width: 100%;
    height: 80vh;
    iframe {
      width: 100%;
      height: 100%;
    }
  }
}
@media (max-width: 768px) {
  #contact{
    padding: 40px var(--main-space);
    .contact-image {
      height: 300px;
      img{
        height: 340px;
      }
    }
    .map-container{
      height: 200px;
    }
  }
}
</style>
